import { Component, Input, Output, EventEmitter, ChangeDetectionStrategy } from '@angular/core';

@Component({
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
  selector: 'conversion-alert',
  templateUrl: './alert.component.html',
  styleUrls: ['./alert.component.css']
})

export class AlertComponent {
  @Input() type: string;
  @Input() header: string;
  @Input() message: string;
  @Input() centertext: boolean;
  @Input() dismissible: boolean = true;
  @Input() triggerAction: boolean;
  @Output() close = new EventEmitter<boolean>();

  closeAlert() {
    this.close.emit(true);
  }
}